import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Header from './components/Header';
import HeaderDefault from './components/HeaderDefault';
import Footer from './components/Footer';
import Home from './pages/Home';
import DeclarationAccessibilite from './pages/DeclarationAccessibilite';
import MentionsLegales from './pages/MentionsLegales';
import reportWebVitals from './reportWebVitals';

const ALLOWED_HOSTS = /^(?:.*\.)?voixhemato\.abbvie\.fr$|^(?:.*\.)?voixhemato\.beta$|^localhost:3000$/;

const HostValidator = ({ children }) => {
  const currentHost = window.location.host;

  if (!ALLOWED_HOSTS.test(currentHost)) {
    return (
      <div>
        <h1>403 Forbidden</h1>
        <p>Invalid Host Header. Access denied for security reasons.</p>
      </div>
    );
  }
  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HostValidator>
      <Router>
        <Routes>
          <Route path="/" element={<Header />} />
          <Route path="/mentions-legales" element={<HeaderDefault />} />
          <Route path="/declaration-accessibilite" element={<HeaderDefault />} />
        </Routes>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/declaration-accessibilite" element={<DeclarationAccessibilite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
        <Footer/>
      </Router>
    </HostValidator>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();